import { Folder, Plan, Project } from '../../../../../atoms/icons/entities'
import { iconSizeOptions } from '../../../../../atoms/icons/icons-sizes'
import { typeFileQuickSelectOptions } from '../../../constants'

export const DefineIcon = ({ itemType }) => {
  if (itemType === typeFileQuickSelectOptions.FOLDER) {
    return <Folder size={iconSizeOptions['ICON-M']} />
  }

  if (itemType === typeFileQuickSelectOptions.PLAN) {
    return <Plan size={iconSizeOptions['ICON-M']} />
  }

  if (itemType === typeFileQuickSelectOptions.PROJECT) {
    return <Project size={iconSizeOptions['ICON-M']} />
  }
}

export default DefineIcon
